<template>
    <v-overlay v-if="show">
        <v-card light color="content" elevation="24" min-width="720px" max-width="720px">
            <v-card-title>
                <v-row>
                    <v-col cols="auto" class="py-0">계약서확인</v-col>
                    <v-spacer />
                    <v-col cols="auto" class="py-0">
                        <v-icon @click="close">mdi-close</v-icon>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text style="max-height: 75vh; overflow-y:auto;">
                <v-card>
                    <v-card-text>
                        <v-row align="baseline">
                            <v-col cols="2" class="pt-0">계약번호</v-col>
                            <v-col class="pt-0 subtitle-1 font-weight-bold">{{ contract.contractNumber }}</v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="2" class="pt-0">계약일</v-col>
                            <v-col class="pt-0 subtitle-1 font-weight-bold">{{ document.signsAt.toDate() }}</v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="2" class="pt-0">현장주소</v-col>
                            <v-col class="pt-0 subtitle-1 font-weight-bold">{{ document.employer.address }}</v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="2" class="pt-0">공사대금</v-col>
                            <v-col class="pt-0">
                                <v-row align="baseline">
                                    <v-col cols="2" class="pt-0">총금액</v-col>
                                    <v-col cols="4" class="pt-0 subtitle-1 font-weight-bold">금 {{ totalAmount.format() }}원</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="2" class="pt-0">계약금</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">금 {{ downpayment.amount.format() }}원</v-col>
                                    <v-col cols="auto" class="pt-0">({{ downpayment.duesAt.toDate() }})</v-col>
                                </v-row>
                                <v-row align="baseline" v-for="(interim, i) in interims" :key="`interim-${i}`">
                                    <v-col cols="2" class="pt-0">중도금{{ i + 1 }}차</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">금 {{ interim.amount.format() }}원</v-col>
                                    <v-col cols="auto" class="pt-0">({{ interim.duesAt.toDate() }})</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="2" class="py-0">잔금</v-col>
                                    <v-col class="py-0 subtitle-1 font-weight-bold">금 {{ balance.amount.format() }}원</v-col>
                                    <v-col cols="auto" class="py-0">({{ balance.duesAt.toDate() }})</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="2" class="pt-0">결제방식</v-col>
                            <v-col class="pt-0 subtitle-1 font-weight-bold">-</v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="2" class="pt-0">입금계좌</v-col>
                            <v-col class="pt-0 subtitle-1 font-weight-bold">-</v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="2" class="py-0">결제증빙</v-col>
                            <v-col class="py-0 subtitle-1 font-weight-bold">{{ contract.taxProof.type }}</v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-row>
                    <v-col cols="5">
                        <v-card>
                            <v-card-title style="border-bottom:1px solid rgba(0,0,0,0.1);">
                                <v-row align="baseline" justify="center">
                                    <v-col cols="auto" class="py-0 subtitle-1">계약자(갑)</v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text>
                                <v-row align="baseline">
                                    <v-col cols="4">성명</v-col>
                                    <v-col class="subtitle-1 font-weight-bold">{{ document.employer.name }}</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="4" class="pt-0">생년월일</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">-</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="4" class="py-0">연락처</v-col>
                                    <v-col class="py-0 subtitle-1 font-weight-bold">{{ document.employer.phone.phoneNumberFormat() }}</v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="7">
                        <v-card>
                            <v-card-title style="border-bottom:1px solid rgba(0,0,0,0.1);">
                                <v-row align="baseline" justify="center">
                                    <v-col cols="auto" class="py-0 subtitle-1">계약자(을)</v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text>
                                <v-row align="baseline">
                                    <v-col cols="4">상호</v-col>
                                    <v-col class="subtitle-1 font-weight-bold">{{ document.employee.businessName }}</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="4" class="pt-0">사업자등록번호</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">{{ document.employee.businessNumber }}</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="4" class="pt-0">주소</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">{{ document.employee.address }}</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="4" class="pt-0">대표자</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">{{ document.employer.name }}</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="4" class="py-0">연락처</v-col>
                                    <v-col class="py-0 subtitle-1 font-weight-bold">{{ document.employer.phone.phoneNumberFormat() }}</v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-card-title style="border-bottom:1px solid rgba(0,0,0,0.1);">
                                <v-row align="baseline" justify="center">
                                    <v-col cols="auto" class="py-0 subtitle-1">계약책임자(병) : 정산 및 AS보증</v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text>
                                <v-row align="baseline">
                                    <v-col cols="3">상호</v-col>
                                    <v-col class="subtitle-1 font-weight-bold">새집처럼</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="3" class="pt-0">사업자등록번호</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">668-88-02025</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="3" class="pt-0">주소</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">경기도 부천시 조마루로 385번길 122, 비204호</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="3" class="pt-0">대표자</v-col>
                                    <v-col class="pt-0 subtitle-1 font-weight-bold">오준택</v-col>
                                </v-row>
                                <v-row align="baseline">
                                    <v-col cols="3" class="py-0">연락처</v-col>
                                    <v-col class="py-0 subtitle-1 font-weight-bold">1600-2325</v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-card-title style="border-bottom:1px solid rgba(0,0,0,0.1);">
                                <v-row align="baseline" justify="center">
                                    <v-col cols="auto" class="py-0 subtitle-1">계약내용</v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col style="white-space:pre-wrap; text-align:justify;">{{ contractContent }}</v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-card-title style="border-bottom:1px solid rgba(0,0,0,0.1);">
                                <v-row align="baseline" justify="center">
                                    <v-col cols="auto" class="py-0 subtitle-1">특약내용</v-col>
                                </v-row>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col style="white-space:pre-wrap; text-align:justify;">{{ document.specialTerms }}</v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-overlay>
</template>
<script>
import initialDocument from "@/assets/data/initialContractDocument.json";
import viewCard from "../dumb/view-card.vue";

import contractContent from "@/assets/data/contractContent";

export default {
    components: { viewCard },
    props: {
        contract: { type: Object, default: null },
    },
    data() {
        return {
            show: false,
            document: { ...initialDocument },
            contractContent,
        };
    },
    methods: {
        open(document_id) {
            this.show = true;
            this.document = this.contract.documents.find(({ _id }) => _id == document_id);
        },
        close() {
            this.show = false;
        },
    },
    computed: {
        totalAmount() {
            return this.document.paymentPlan.reduce((totalAmount, { amount }) => totalAmount + amount, 0);
        },
        downpayment() {
            return this.document.paymentPlan.find(({ type }) => type == "계약금");
        },
        balance() {
            return this.document.paymentPlan.find(({ type }) => type == "잔금");
        },
        interims() {
            return this.document.paymentPlan.filter(({ type }) => type == "중도금");
        },
    },
};
</script>
